export default "__VITE_ASSET__4x6xxYxy__"